import { Link } from 'react-router-dom';
import { EmptyState, LockedIllustration, NotFoundIllustration } from '@/components/ui/layout';
import { Button } from '@/components/ui/primitives';

export function NotFoundPage() {
  return (
    <EmptyState
      illustration={<NotFoundIllustration />}
      title="That screen is not here"
      description="The page may belong to a module your hospital has not enabled, or the link may be out of date."
      action={
        <Button onClick={() => window.history.back()}>Go back</Button>
      }
    />
  );
}

export function ModuleDisabled({ module }: { module: string }) {
  return (
    <EmptyState
      illustration={<LockedIllustration />}
      title={`The ${module} module is not enabled`}
      description="Your hospital's plan does not include this module. Contact your administrator to have it switched on."
      action={
        <Link to="/dashboard">
          <Button variant="outline">Back to dashboard</Button>
        </Link>
      }
    />
  );
}
